<!--
  - Copyright (c) 2022-2023. Haodong JU
  -->

<template>
  <div
    class="pa-4 px-6"
  >
    <div>
      <div class="d-flex align-center">
        <div class="text-h4 font-weight-medium">
          {{ $t('option') }}
        </div>
        <v-spacer />
        <v-btn
          class="pt-1"
          color="amber lighten-4 black--text"
          elevation="0"
          @click="startAddGroup"
        >
          <v-icon
            left
          >
            mdi-plus
          </v-icon>
          <div v-if="currentSelectedList.length>0">
            {{ $t('add_other_select_sort') }}
          </div>
          <div v-else>
            {{ $t('changeAttribute') }}
          </div>
        </v-btn>
      </div>

      <div
        v-if="currentSelectedList.length===0"
        class="text-body-2 mt-8"
      >
        <!--        如果需要为产品添加选项，例如，添加温度，糖度，Topping等，请点击下方的添加选项按钮-->
        {{
          $t('append_new_option_click_button_below')
        }}
      </div>
    </div>
    <v-divider class="my-4" />
    <div>
      <loading-provider :loading="loading">
        <attribute-card
          v-for="ag in currentSelectedList"
          :key="ag.id"
          :ag="ag"
          :selected-a-id-list="selectedAIdList"
          @remove-ag="toggleAttributeGroup(ag.id)"
          @toggle-attribute="toggleAttributeActive"
        />
      </loading-provider>
    </div>

    <v-dialog
      v-model="showCreateAgDialog"
      max-width="500px"
    >
      <v-card>
        <div class="d-flex align-center pa-4">
          <div class="text-h4 font-weight-bold">
            {{ $t('CreateAttributeGroup') }}
          </div>
          <v-spacer />
        </div>

        <div class="pa-4">
          <template v-if="!createAgStep">
            <div class="text-body-1">
              {{ $t('AttributeName') }}
            </div>
            <div
              class="text-body-2 text--secondary"
            >
              {{ $t('AttributeNameHint') + ' ' }}<b class="blue--text text--darken-4">"{{
                $t('AttributeNameHint2')
              }}"</b>{{ ' ' + $t('AttributeNameHint3') }} {{ $t('TaxRate') }}
            </div>
            <v-text-field
              v-model="editAG.name"
              autofocus
              class="mt-2"
              dense
              hide-details
              outlined
            />
            <div
              v-if="editAG.name"
              class="text-body-1 mt-6"
            >
              {{ $t('MoreAttributeOptions') }}:
            </div>
            <div
              v-if="editAG.name"
              class="mt-2"
            >
              <div style="display: grid;grid-template-columns: repeat(2,minmax(0,1fr));grid-gap: 16px">
                <v-tooltip
                  bottom
                  color="grey lighten-4"
                >
                  <template #activator="{on,attrs}">
                    <div
                      class="d-flex align-center"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-simple-checkbox
                        v-model="editAG.required"
                        dense
                        hide-details
                      />
                      <div class="text-body-2">
                        {{ $t('required') }}
                      </div>
                      <v-icon
                        class="ml-1"
                        small
                      >
                        mdi-help-circle
                      </v-icon>
                    </div>
                  </template>
                  <div
                    class="text-caption text--secondary"
                  >
                    {{ $t('RequiredHint') }}
                  </div>
                </v-tooltip>
                <v-tooltip
                  bottom
                  color="grey lighten-4"
                >
                  <template #activator="{on,attrs}">
                    <div
                      class="d-flex align-center"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-simple-checkbox
                        v-model="editAG.multiple"
                        dense
                        hide-details
                      />
                      <div class="text-body-2">
                        {{ $t('multiSelect') }}
                      </div>
                      <v-icon
                        class="ml-1"
                        small
                      >
                        mdi-help-circle
                      </v-icon>
                    </div>
                  </template>
                  <div
                    class="text-caption text--secondary"
                  >
                    {{
                      $t('e.g_add_ingrendients_topping_cound_be_added_multiple_ice_sugar_size_can_be_selected_just_one')
                    }}
                  </div>
                </v-tooltip>
              </div>
            </div>
            <v-btn
              v-if="editAG.name"
              block
              class="mt-6"
              color="amber lighten-4 black--text"
              elevation="0"
              @click="createAgStep=true"
            >
              {{ $t('nextStep') }}
            </v-btn>
          </template>
          <template v-else>
            <div>
              <div class="text-body-1">
                {{ $t('AddNewCreatedAttributeToGroup') }} <b class="blue--text text--darken-4">"{{ editAG.name }}"</b>
                {{ $t('AddNewCreatedAttributeToGroup2') }}
              </div>
              <div
                class="text-body-2 text--secondary mt-1"
              >
                {{ $t('if_it_needs_to_adjust_tax_rate_pictures_should_edit_in_details') }}
              </div>
            </div>

            <div
              v-for="(a,index) in addedAttributes"
              :key="a.key"
              class="d-flex align-center mb-1 mt-4"
            >
              <v-text-field
                v-model="a.name"
                :placeholder="$t('AttributeGroupNameHint')"
                dense
                hide-details
                outlined
              />
              <div style="width: 16px" />
              <div style="width: 120px">
                <v-text-field
                  v-model="a.price"
                  :placeholder="$t('price')"
                  append-icon="mdi-cash"
                  dense
                  hide-details
                  outlined

                  step="0.5"
                  type="number"
                />
              </div>

              <div style="width: 60px">
                <v-btn
                  :disabled="addedAttributes.length===1||(!a.price&&!a.name)"
                  class="ml-1"
                  icon
                  @click="addedAttributes.splice(index,1)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </div>
            </div>
            <div class="d-flex mt-12">
              <v-card
                class="pa-3 d-flex align-center justify-center"
                color="grey lighten-4 black--text"
                depressed
                elevation="0"
                style="border-radius: 36px !important;"
                @click="createAgStep=false"
              >
                <v-icon>
                  mdi-arrow-left
                </v-icon>
              </v-card>
              <v-btn
                :disabled="needToAdd.length===0"
                class="ml-2 flex-grow-1"
                color="amber lighten-4 black--text"
                depressed
                @click="createAndSave"
              >
                {{ $t('SaveAndAdd') }}
                <v-icon right>
                  mdi-check
                </v-icon>
              </v-btn>
            </div>
          </template>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showAddAGDialog"
      max-width="500px"
    >
      <v-card>
        <div class="grey lighten-4 pa-4">
          <div class="d-flex align-center ">
            <div>
              <div class="text-h4 font-weight-bold">
                {{ $t('AddAttributeArticles') }}
              </div>
              <div class="text-body-2 text--secondary">
                {{ $t('SelectAttributeArticles') }}
              </div>
            </div>

            <v-spacer />
            <v-btn
              icon
              @click="showAddAGDialog=false"
            >
              <v-icon>
                mdi-close
              </v-icon>
            </v-btn>
          </div>
        </div>

        <div class="px-4">
          <div style="max-height: 400px;overflow-y: scroll">
            <div class="mt-2" />
            <v-card
              class="py-2 text-body-2 yellow--text text--darken-4"
              flat
              @click="createAttributeGroup"
            >
              <div class="d-flex align-center">
                <div class="text-body-2 font-weight-bold">
                  {{ $t('CreateAttributeArticles') }}
                </div>
                <v-spacer />
                <v-icon
                  color="yellow darken-4"
                  style="margin-right: 10px"
                >
                  mdi-plus-box
                </v-icon>
              </div>
            </v-card>
            <v-card
              v-for="ag in currentNotSelectedList"
              :key="ag.id"
              class="py-2"
              elevation="0"
              @click="toggleSelectedAg(ag.id)"
            >
              <div class="d-flex align-center">
                <div class="text-body-2 font-weight-medium">
                  {{ ag.name }}
                </div>
                <v-spacer />
                <v-simple-checkbox
                  :value="selectedAG.includes(ag.id)"
                  @click.stop="toggleSelectedAg(ag.id)"
                />
              </div>
              <div class="text-caption">
                {{ ag.attributes.map(it => it.name).join(', ') }}
              </div>
            </v-card>
          </div>
        </div>
        <div class="pa-4 py-2">
          <v-btn
            :disabled="selectedAG.length===0"
            block
            color="amber lighten-4 black--text"
            elevation="0"
            @click="saveAndReload"
          >
            {{ $t('add') }}
            <v-icon right>
              mdi-check
            </v-icon>
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AttributeCard from '@/views/AadenPages/dishes/dish/detail/fragments/widget/AttributeCard'
import Attribute, { flipAttributes, toggleAttributeGroup } from '@/model/dataLayer/api/dish/Attribute'
import { groupBy } from 'lodash-es'
import AttributeGroup from '@/model/dataLayer/api/dish/AttributeGroup'
import IKUtils from 'innerken-js-utils'
import { checkDishDetail } from '@/model/dataLayer/api/dish/Dish'
import LoadingProvider from '@/views/widget/LoadingProvider.vue'

let counter = 0
const defaultAttributeGroup = {
  name: '',
  required: true,
  multiple: false
}

const defaultAttribute = {
  name: '',
  price: ''
}

export default {
  name: 'AttributeEditFragment',
  components: {
    LoadingProvider,
    AttributeCard
  },
  props: {
    dishesId: {}
  },
  data () {
    return {
      attributeGroupList: [],
      addedAttributes: [this.createDefaultAttribute()],
      newAddedAttributeGroupList: [],
      selectedAGIdList: [],
      selectedAIdList: [],
      loading: false,

      Attribute,

      showAddAGDialog: null,

      createAgStep: false,
      showCreateAgDialog: null,
      editAG: this.createDefaultAG(),
      showHelpText: true,
      selectedAG: []
    }
  },
  computed: {
    currentSelectedList () {
      return this.attributeGroupList
        .filter(it => this.selectedAGIdList.includes(it.id.toString()))
    },
    currentNotSelectedList () {
      return this.attributeGroupList
        .filter(it => !this.selectedAGIdList.includes(it.id.toString()))
    },
    needToAdd () {
      return this.addedAttributes.filter(it => it.name)
    }
  },
  watch: {
    dishesId: {
      immediate: true,
      handler () {
        this.initial()
      }
    },
    addedAttributes: {
      deep: true,
      handler (val) {
        const emptyNode = val.filter(it => !it.name && !it.price).length
        if (emptyNode === 0) {
          this.addedAttributes.push(this.createDefaultAttribute())
        }
      }
    }
  },
  async mounted () {
    await this.initial()
  },
  methods: {
    async saveAndReload () {
      IKUtils.showLoading()
      for (const id of this.selectedAG) {
        await this.toggleAttributeGroup(id)
      }
      this.showAddAGDialog = false
      IKUtils.toast(this.$t('addSuccess'))
    },
    async createAndSave () {
      this.editAG.required = this.editAG.required ? 1 : 0
      this.editAG.multiSelect = this.editAG.multiple ? 1 : 0
      this.editAG.printTitle = this.editAG.name
      const agId = (await AttributeGroup.add(this.editAG)).id
      let counter = 1
      for (const a of this.needToAdd) {
        a.attributeGroupId = agId
        a.printMod = a.name
        a.value = counter++

        a.priceMod = a.price || 0
        a.dishesCategoryTypeId = 9
        a.isActive = 1
        await Attribute.add(a)
      }
      await this.reloadAttributeList()
      this.selectedAG.push(agId)
      this.showCreateAgDialog = false
    },
    startAddGroup () {
      this.selectedAG = []
      this.showAddAGDialog = true
    },
    createDefaultAG () {
      const obj = IKUtils.deepCopy(defaultAttributeGroup)
      obj.key = counter++
      return obj
    },
    toggleSelectedAg (id) {
      if (this.selectedAG.includes(id)) {
        this.selectedAG = this.selectedAG.filter(it => it !== id)
      } else {
        this.selectedAG.push(id)
      }
    },
    createAttributeGroup () {
      this.showCreateAgDialog = true
      this.editAG = this.createDefaultAG()
      this.createAgStep = false
      this.addedAttributes = [this.createDefaultAttribute()]
    },
    createDefaultAttribute () {
      const obj = IKUtils.deepCopy(defaultAttribute)
      obj.key = counter++
      return obj
    },
    async initial () {
      await this.wait(async () => {
        await this.reloadModInfo()
      })
    },

    async reloadAttributeList () {
      const dict = groupBy(await Attribute.getList(true), 'attributeGroupId')
      this.attributeGroupList = (await AttributeGroup.getList(true)).map(it => {
        it.attributes = dict[it.id] ?? []
        return it
      })
    },

    async getModDetail () {
      const res = await checkDishDetail(this.dishesId)
      const formattedModInfo = res.modInfo?.map(it => {
        return {
          id: it.id,
          aId: it.selectValue?.split(',') ?? []
        }
      }) ?? []
      const inheritAttributeGroupId = res.inheritAttributeGroupId ? [...res.inheritAttributeGroupId.split(',')] : []
      const localAttributeGroupId = res.localAttributeGroupId ? [...res.localAttributeGroupId.split(',')] : []
      const agList = [...new Set([...inheritAttributeGroupId, ...localAttributeGroupId])].join(',') ?? ''
      // const agList = formattedModInfo.map(it => it.id)
      const aList = formattedModInfo.map(it => it.aId).flat()
      return [agList, aList]
    },
    async reloadModInfo () {
      await this.reloadAttributeList();
      [this.selectedAGIdList, this.selectedAIdList] = await this.getModDetail(this.dishesId)
      this.$emit('update-mod-list', this.selectedAGIdList)
    },

    async afterEdit () {
      this.loading = false
    },

    async toggleAttributeGroup (agId) {
      this.loading = true
      await toggleAttributeGroup(agId, this.dishesId)
      await this.reloadModInfo()
      await this.afterEdit()
    },

    async toggleAttributeActive (aId, agId, done) {
      try {
        await flipAttributes(this.dishesId, agId, aId)
        await this.reloadModInfo()
      } finally {
        if (typeof done === 'function') {
          done()
        }
        await this.afterEdit()
      }
    },

    async wait (action) {
      this.loading = true
      try {
        await action()
      } catch (e) {

      }
      this.loading = false
    },

    close () {
      this.$router.back()
    }
  }

}
</script>

<style scoped>

</style>
